// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"6d04840a","48":"d9e4badb","326":"4cd35fb9","433":"4d1405cf","546":"5bf146fe","569":"4c33f91d","606":"487975aa","671":"20658657","700":"5f781c11","747":"be42c6a0","754":"3c57c4eb","803":"044cb4b9","830":"004d9444","998":"5d1a1938"}[chunkId] + ".chunk.js";
};